import React from 'react'
import {addLocaleData, IntlProvider} from 'react-intl'
import enLocaleData from 'react-intl/locale-data/en'
import frLocaleData from 'react-intl/locale-data/fr'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

const HotSwapIntlProvider = (props) => (
	<IntlProvider {...props} key={props.locale} />
)
HotSwapIntlProvider.propTypes = {
	locale: PropTypes.string.isRequired
}


const mapStateToProps = (state, ownProps) => ({
	locale: state.i18n.locale,
	messages: state.i18n.messages
})

const mapDispatchToProps = (dispatch, ownProps) => ({
})

addLocaleData(enLocaleData)
addLocaleData(frLocaleData)
// A fake `"en-pseudo"` locale is created so translations can be emulated.
addLocaleData({
	locale: 'en-pseudo',
	parentLocale: 'en',
})


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(HotSwapIntlProvider)



// WEBPACK FOOTER //
// ./src/IntlProvider.js